// Clipboard helper that works in non-secure contexts.
//
// navigator.clipboard.writeText() is only available on HTTPS or localhost.
// On http://<lan-ip>:5173/ (a common dev setup) it's silently blocked, which
// makes "Copy link" actions look broken. This wraps the modern API and falls
// back to a hidden <textarea> + document.execCommand('copy') trick that
// works in every browser on every origin.

export async function copyToClipboard(text: string): Promise<boolean> {
  // Preferred path: async Clipboard API. Requires a secure context.
  if (typeof navigator !== 'undefined' && navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // fall through to the legacy path
    }
  }

  // Legacy fallback. Works on http:// and inside iframes that block
  // navigator.clipboard. The textarea must be visible-ish in the DOM at
  // selection time, so we position it off-screen rather than display:none.
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '0';
    ta.style.left = '0';
    ta.style.opacity = '0';
    ta.style.pointerEvents = 'none';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    ta.setSelectionRange(0, text.length);
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
